// @flow
import { themeStyle } from '../colorPalettes'

import { lightTheme } from './lightTheme'
import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const eztvThemeName = 'eztv'

export const themeEztv: ThemeType = {
  name: eztvThemeName,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.light:
        return lightTheme
      case themeStyle.dark:
        return darkTheme
      default:
        return lightTheme
    }
  },
}
